import _ from 'lodash/fp'
import { setField, setFieldWith } from 'prairie'
import React, { useEffect, useState } from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import hash from 'object-hash'
// import classNames from 'classnames'
import { ReactSortable } from 'react-sortablejs'
// import { createCollectionUrl } from '../utils/path.js'
import { getIds, post } from '../services/lists.js'
import { getItemId } from '../utils/index.js'

import Page from '../components/layout/index.jsx'
import Select from '../components/editable/select.jsx'
import RelatedColor from '../components/detail/related-color.jsx'

import '../styles/login.css'

const fixColorItems = _.flow(
  _.map(_.flow(
    setFieldWith('sortedIdsDefault', 'nodes', _.map('id')),
    _.update('nodes', _.keyBy('id')),
  )),
  _.keyBy('fieldValue'),
)
function ColorSort({ data: { colors, data: { groups } } }) {
  const colorOpts = colors.options
  const defaultColorId = colorOpts[0].value
  // const [{ activeColorId, sortedIds }, setColor] = useState({
  //   activeColorId: defaultColorId,
  //   sortedIds: null,
  // })
  const [activeColorId, setColor] = useState(defaultColorId)
  const [isDisabled, setDisabled] = useState(false)
  const [sortedIds, setIdOrder] = useState([])
  const itemsByColor = fixColorItems(groups)

  // console.log('sortedIds', sortedIds)
  const { nodes, sortedIdsDefault } = itemsByColor[activeColorId]

  useEffect(() => {
    getIds(activeColorId, sortedIdsDefault).then(setIdOrder)
  }, [activeColorId])

  const colorItems = sortedIds.map((id) => nodes[id]).filter(_.isPlainObject)

  function handleSort(items) {
    if (_.isEmpty(items)) return
    const sortedIdsLatest = items.map(_.get('id'))
    if (hash(sortedIdsLatest) === hash(sortedIds)) {
      // console.log('ignore same sort', _.now())
      return
    }
    setDisabled(true)
    setIdOrder(sortedIdsLatest)
    post({
      activeColorId,
      sortedIds: sortedIdsLatest,
    }).then(() => setDisabled(false))
    // console.log('sorted', sortedIdsLatest, sortedIds, _.now())
  }
  function handleColorChange(e) {
    const colorId = e.target.value
    console.log('change color', colorId)
    setIdOrder([])
    setColor(colorId)
  }
  colorItems.forEach((item) => {
    if (!item || !item.pattern?.category?.id) {
      console.log(item)
    }
  })
  return (
    <Page path="/login">
      <div
        id="color-sort"
        style={{ marginTop: '3em' }}
      >
        <h3 className="uppercase">Manual Color Ordering</h3>
        <div>
          <Select
            label="Primary Color"
            onChange={handleColorChange}
            options={colorOpts}
            value={activeColorId}
            style={{ marginBottom: '1rem' }}
          />
          <ReactSortable
            className="grid"
            disabled={isDisabled}
            list={colorItems}
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(10%, 1fr))',
              gap: '.6rem',
            }}
            setList={handleSort}
          >
            {_.map(
              ({ color, colorId, pattern }) => (
                <div
                  key={getItemId(pattern, { colorId })}
                  className="sortableItem"
                  style={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    backgroundColor: 'var(--rg-whiteGold)',
                    cursor: 'move',
                  }}
                >
                  <RelatedColor
                    isActive
                    color={color}
                    colorId={colorId}
                    categoryId={pattern.category.id}
                    itemId={getItemId(pattern, { colorId })}
                    image={{ keyword: 'normal' }}
                    style={{ padding: '0' }}
                    patternId={pattern.patternId}
                  />
                  <ul
                    className="list-reset"
                    style={{
                      fontSize: '0.8rem',
                      lineHeight: '1.1em',
                      textAlign: 'left',
                      marginTop: '.3rem',
                      paddingBottom: '.3rem',
                      borderBottom: '1px solid var(--rg-gray)',
                    }}
                  >
                    <li>{pattern.name}</li>
                    <li>{color}</li>
                    <li>
                      {pattern.patternId}
                      -
                      {colorId}
                    </li>
                  </ul>
                </div>
              ),
              colorItems,
            )}
          </ReactSortable>
        </div>
      </div>
    </Page>
  )
}

ColorSort.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.shape({
      frontmatter: PropTypes.shape({
        title: PropTypes.string.isRequired,
        intro: PropTypes.string.isRequired,
      }),
      html: PropTypes.string,
    }),
  }).isRequired,
}

export default ColorSort

export const pageQuery = graphql`
{
  colors:allColorsYaml(sort: {fields: position}) {
    options:nodes {
      label
      position
      value: id
    }
  }
  data:allColorItem(
    sort: {fields: colorPosition}
    filter: {pattern: {unpublished: {ne: true}}}
  ) {
    groups:group(field: colorPrimary___id) {
      nodes {
        colorId
        pattern {
          category { id }
          patternId
          name
        }
        color
        colorPosition
        id
      }
      fieldValue
    }
  }
}
`
